import configCommon from "./config.common.json";
import configDevelop from "./config.develop.json";
import configRecette from "./config.recette.json";
import configStaging from "./config.staging.json";
import configProd from "./config.prod.json";

interface CommonConfig {
  defaultLanguage: string;
  snackbarTimeout: number;
  need_help_url: string;
  locales: { name: string; value: string }[];
  timezones: { name: string; value: string }[];
  status: { name: string; value: string }[];
  validations: {
    bilanNameMinSize: number;
    minSize: number;
  };
}
interface EnvConfig {
  api_url: string;
  sentry: {
    dsn: string;
    environment: string;
    debug: boolean;
    sample_rate: number;
  };
}
let conf: EnvConfig & CommonConfig;

switch (process.env.NODE_ENV) {
  case "development":
  case "heroku_dev":
  case "develop":
    conf = { ...configDevelop, ...configCommon };
    break;

  case "recette":
    conf = { ...configRecette, ...configCommon };
    break;

  case "staging":
    conf = { ...configStaging, ...configCommon };
    break;

  case "production":
    conf = { ...configProd, ...configCommon };
    break;

  default:
    throw new Error("Env " + process.env.NODE_ENV + " is not an accepted value.");
}

const config = conf;

export default config;
